module.exports = "/assets/f0336a2e9fe51b3ac512917e35ee5612.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/K6.png
// module id = 2658
// module chunks = 0